import {
  init as initAutocomplete,
  filter as filterAutocomplete,
  close as closeAutocomplete,
} from './store-list-autocomplete';

import {
  disableNonExistantLetters,
  scrollToLetter,
} from './store-list-letters';

export function init() {
  // Init LetterList
  disableNonExistantLetters();

  // LetterList action
  $('.storelist-bloc-letters a').on('click', scrollToLetter);

  // Init Autocomplete
  const $listResult = $('#storelist__filtered-list');
  const $listNoResult = $('#storelist__filtered-list__error');
  initAutocomplete($listResult, $listNoResult);

  // Autocomplete actions
  $('#storelistFilter').on('input', filterAutocomplete);
  $('body').on('click', closeAutocomplete);
}



// WEBPACK FOOTER //
// ./src/store/store-list/store-list.js